let initialized = false;

function parseVisibleValues(rawValue = "") {
  return rawValue
    .split(",")
    .map((value) => value.trim())
    .filter(Boolean);
}

function updateVariantConditionalImages(variant) {
  if (!variant) {
    return;
  }

  document.querySelectorAll("[data-product-variant-image]").forEach((element) => {
    const optionPosition = parseInt(element.dataset.optionPosition, 10);
    const visibleValues = parseVisibleValues(element.dataset.visibleValues);
    const currentValue = variant[`option${optionPosition}`];
    element.hidden = !visibleValues.includes(currentValue);
  });
}

function initProductVariantImage() {
  if (initialized) {
    return;
  }

  initialized = true;
  document.addEventListener("variant:change", (event) => {
    updateVariantConditionalImages(event.detail?.variant);
  });
}

initProductVariantImage();
